// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__xZwil","sendOtp":"AuthorizeToLogin_sendOtp__1wMfa"};